<template>
  <div class="opt_more_g" :class="{'on': isOpen}" ref="tooltipPosiEl"><!-- _open 으로 활성화 (tooltipControlMixin) -->
    <slot name="activator" :on="on" :title="title">
      <!--<a href="javascript:void(0);" class="link_item _closeControl" @click.stop="clickButton">{{title}}
        <span class="screen_out">정렬</span><span class="ico_comm ico_arrow_toggle"></span>
      </a>-->
    </slot>
    <div class="box_opt_menu posi_r type_toggle" v-if="list.length > 0">
      <div class="menu_item" v-for="item in list" :key="'sort' + item.label + item.code">
        <a href="javascript:void(0);" class="link_menu" @click="clickMenu(item)">{{item.label}}</a>
      </div>
    </div>
  </div>
</template>

<script>
  import tooltipControlMixin from "@/mixins/tooltipControl";

  export default {
    name: "TooltipMenu",
    mixins: [tooltipControlMixin],
    model: {
      event: 'change'
    },
    props: {
      list: {
        type: Array,
        default() {
          return []
        }
      },
      value: {
        type: null
      }
    },
    data() {
      return {
        isOpen: false,
        isDownPosi: false,
        on: {
          click: this.clickButton,
        },
      }
    },
    computed: {
      title() {
        const item = this.list.find(item=>item.code === this.value.code);
        return item ? item.label : '';
      }
    },
    methods: {
      clickMenu(item) {
        this.$emit('change', item);
      },
      clickButton(e) {
        e.stopPropagation();
        this.tooltipControl(); // tooltipControlMixin 메서드
      }
    }
  }
</script>

<style scoped>

</style>
